import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import BreadCrumbs from '../../molecules/breadcrumbs';
import ProductCarousel from '../../tissues/product-carousel';
import MobilePDPImageCarousel from '../../tissues/pdp-mobile-image-carousel';
import ProductInformation from '../../organisms/pdp-information';
import PDPCarousels from '../pdp-carousels';
import BazaarVoiceRating from '../../atoms/bazaar-voice/ratings';

const ProductWrapper = styled.div``;

const Product = styled.div`
  display: grid;
  grid-gap: 3rem;
  grid-template-areas: 'breadcrumbs' 'product-carousel' 'product-information';
  grid-template-columns: minmax(0, 1fr);
  margin-bottom: 3rem;

  @media (min-width: ${(props) => props.theme.breakpoint.medium}) {
    grid-gap: 5rem;
    grid-template-columns: 50%;
    grid-template-areas: 'breadcrumbs breadcrumbs' 'product-carousel product-information';
  }
`;

const ProductDetails = ({
  product, hasImages, productType, hasRecommendations, recentlyViewed, meta, growthbookFeatureFlagValues
}) => (
  <ProductWrapper>
    <Product>
      <BreadCrumbs breadcrumbs={product?.breadcrumb_taxons || []} />

      {
        hasImages && (
          <>
          <ProductCarousel
            product={product}
            images={product?.master?.images}
            name={product?.master?.name}
            productType={productType}
          />

          <MobilePDPImageCarousel 
            product={product}
            images={product?.master?.images}
            name={product?.master?.name}
            productType={productType}
            />
        </>
        )
      }
      <ProductInformation product={product} meta={meta} growthbookFeatureFlagValues={growthbookFeatureFlagValues}/>
    </Product>

    {/* TODO: TEC-8758 - For BV we're currently using the slug instead of product
              id because of a backend data issue with the product feed. If the BE
              fix the data issue, we will need to update data-bv-product-id to 
              the correct value. */}
    <BazaarVoiceRating show="reviews" productId={product?.master?.slug}/>
    
    <PDPCarousels
      product={product}
      recentlyViewed={recentlyViewed}
      hasRecommendations={hasRecommendations}
    />
  </ProductWrapper>
);

ProductDetails.defaultProps = {
  product: null,
  hasImages: false,
  productType: '',
  hasRecommendations: false,
  recentlyViewed: [],
  meta: {},
  growthbookFeatureFlagValues: {},
};

ProductDetails.propTypes = {
  product: PropTypes.object,
  hasImages: PropTypes.bool,
  productType: PropTypes.string,
  hasRecommendations: PropTypes.bool,
  recentlyViewed: PropTypes.array,
  meta: PropTypes.object,
  growthbookFeatureFlagValues: PropTypes.object,
};

export default ProductDetails;
